<template>
  <div style="margin:2px">
    <div class="bg_container">
      <!-- <img src="../assets/wellness_coupon_bg.png" alt /> -->
    </div>

    <div class="head_container">
      <div class="icon_text_container">
        <img class="icon" src="../assets/heals_logo.png" alt />
        <div>heals</div>
      </div>
      <div class="money_detail_container">
        <div class="wellness_priority">your wellness is our priority</div>
        <div class="money_count">HK${{couponObj.amount}}</div>
        <div class="wellness_coupon">wellness coupon</div>
        <img class="qr_code_image" v-bind:src="qrCodeUrl" alt />
        <div class="hint_detail">{{couponObj.validityPeriod}}</div>
      </div>
    </div>
    <!--  -->
    <div class="coupon_valid_table_container">
      <div class="coupon_detail_container">
        <div class="section_title">Coupon valid for the following services</div>
        <!-- 服务列表 -->
        <div class="services_list_container">
          <div class="one_item" v-for="(item,i) in serviceItemsArray" v-bind:key="i">
            <div
              v-for="(oneItem,i) in item.itemArray"
              v-bind:key="i"
              class="item_one_item_contianer"
            >
              <div class="type_title_container">
                <div class="point"></div>
                <div class="type">{{oneItem.title}}:</div>
              </div>
              <div class="text_container">
                <div
                  class="text"
                  v-for="(sutTitle,i) in oneItem.subTitleItems"
                  v-bind:key="i"
                >{{sutTitle}}</div>
              </div>
            </div>
            <div class="undline"></div>
          </div>
        </div>

        <!-- How to redeem -->
        <div class="section_title" style="margin-top:0.5rem">How to redeem</div>
        <div class="sub_section_title" v-for="(item,i) in redeemItems" v-bind:key="i">
          <div class="number">{{i+1}})</div>
          <div>{{item}}</div>
        </div>
        <div class="service_location_title">Service locaitons</div>
        <!-- service locations -->
        <div class="services_list_container">
          <div class="one_item" v-for="(item,i) in serviceLocationItems" v-bind:key="i">
            <div
              v-for="(oneItem,i) in item.itemArray"
              v-bind:key="i"
              class="item_one_item_contianer"
            >
              <div class="type_title_container">
                <div class="point"></div>
                <div class="type">{{oneItem.title}}:</div>
              </div>
              <div class="text_container">
                <div
                  class="text"
                  v-for="(sutTitle,i) in oneItem.subTitleItems"
                  v-bind:key="i"
                >{{sutTitle}}</div>
              </div>
            </div>
            <div class="undline"></div>
          </div>
        </div>
        <!-- Terms and conditions -->
        <div class="section_title" style="margin-top:0.5rem">Terms and conditions</div>
        <div class="sub_section_title" v-for="(item,i) in conditionsItems" v-bind:key="'item' +i">
          <div class="number">{{i+1}})</div>
          <div>{{item}}</div>
        </div>
        <div class="heals_healthcare_limited">Proudly brought to you by Heals Healthcare Limited</div>

        <!-- heals app download -->
        <div class="heals_app_download_info_container">
          <img class="heals_app_qr_code_image" src="../assets/heals_app_qr_code.png" alt />
          <div class="download_button_container">
            <a href="https://play.google.com/store/apps/details?id=com.healshealthcare.patientapp">
              <img src="../assets/download_andrid.png" alt />
            </a>
            <a href="https://apps.apple.com/hk/app/heals-patient-app/id1442752092">
              <img src="../assets/download_ios.png" alt />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "wellness-coupon",
  data() {
    return {
      qrCodeUrl: "",
      token: "",
      couponObj: {},
      serviceItemsArray: [],
      serviceLocationItems: [],
      redeemItems: [
        "Call the booking number and state your desired service.",
        "Show your wellness coupon to the nurse.",
        "Pay the additional payment to clinic if necessary."
      ],
      conditionsItems: [
        "wellness coupons are valued at HK$1,500 and can only be redeemable against selected services at specified locations.",
        "wellness coupons are transferrable and can be used cumulatively.",
        "wellness coupons must be consumed on/before the expiry date.",
        "Wellness coupons are not redeemable for cash.Unused residual value cannot be redeemed for cash.",
        "No replacement for last or stolen wellness coupons.",
        "In the event that the value of the wellness coupon does not cover for the full cost of services,the balance must be paid by the redeemer.",
        "The management retains the right to reject any wellness coupons which have been tempered with or found in any way unacceptable.",
        "The management resserves the right to change these terms and conditions without notice."
      ]
    };
  },

  mounted() {
    this.token = this.$route.params.token;
    //加载优惠卷信息
    this.$get(
      "/mp/coupon/information",
      { token: this._data.token },
      this,
      {}
    ).then(data => {
      data.coupon.validityPeriod =
        "expiry date: " +
        data.coupon.offer_date +
        " ~ " +
        data.coupon.expiry_date;
      this.couponObj = data.coupon;
    });

    // 加载二维码图片
    this.$get("/mp/coupon/qrCode", { token: this._data.token }, this, {}).then(
      data => {
        this.qrCodeUrl = data.qrCode;
      }
    );

    //加载优惠卷服务列表
    this.$get("/mp/coupon/coupon_item", {}, this, {}).then(data => {
      var serviceItemsArray = [];
      for (let index in data.item) {
        let model = data.item[index];

        let serviceModel = { title: "Service", subTitleItems: [] };
        let locationModel = { title: "Location", subTitleItems: [] };
        let addonModel = { title: "Add-On", subTitleItems: [] };
        for (let newIndex in model.translations) {
          let newModel = model.translations[newIndex];
          switch (newModel.locale) {
            case "en":
              serviceModel.enName = newModel.name;
              break;
            case "zh-Hant":
              serviceModel.hantName = "(" + newModel.name + ")";
              break;
            default:
              break;
          }
        }
        for (let newIndex in model.coupon_clinic) {
          let newModel = model.coupon_clinic[newIndex];
          locationModel.subTitleItems.push(newModel.name);
        }

        serviceModel.subTitleItems.push(serviceModel.enName);
        serviceModel.subTitleItems.push(serviceModel.hantName);

        addonModel.subTitleItems.push(model.add_on);
        let result = { itemArray: [serviceModel, locationModel, addonModel] };
        serviceItemsArray.push(result);
      }
      this.serviceItemsArray = serviceItemsArray;
    });
    // 加载服务诊所列表
    this.$get("/mp/coupon/coupon_clinic", {}, this, {}).then(data => {
      var serviceItemsArray = [];
      for (let index in data.couponClinic) {
        let model = data.couponClinic[index];

        let serviceModel = { title: "Location", subTitleItems: [model.name] };
        let addressModel = { title: "Address", subTitleItems: [] };
        let phoneModel = { title: "Booking", subTitleItems: [model.phone] };
        for (let newIndex in model.translations) {
          let newModel = model.translations[newIndex];
          switch (newModel.locale) {
            case "en":
              addressModel.enName = newModel.address;
              break;
            case "zh-Hant":
              addressModel.hantName = "(" + newModel.address + ")";
              break;
            default:
              break;
          }
        }
        addressModel.subTitleItems.push(addressModel.enName);
        addressModel.subTitleItems.push(addressModel.hantName);

        let result = { itemArray: [serviceModel, addressModel, phoneModel] };
        serviceItemsArray.push(result);
      }
      this.serviceLocationItems = serviceItemsArray;
    });
  },
  methods: {
 
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../style/wellness-coupon.css";
</style>



// WEBPACK FOOTER //
// src/components/wellness-coupon.vue